import { Injectable, Output, EventEmitter } from '@angular/core';
import {AuthedApiService} from './authed-api.service';
import {AccountInfoService} from './user/account-info.service';


@Injectable({
  providedIn: 'root'
})
export class AdminEnvironmentHandlerService {

  currentEnvironment: any;
  partnerShortCode: any;
  isDataSet = false;
  allEnvironments: any;

  @Output() onEnvironmentChange = new EventEmitter<any>();

  constructor(
      public authedAPIService: AuthedApiService,
      public accountInfoService: AccountInfoService
  ) { }

  hasAdminEnvironmentSettingsDataSet() {
    return this.isDataSet;
  }

  initAdminEnvironment() {
    this.partnerShortCode = this.accountInfoService.partnerShortCode;
    this.authedAPIService.getPartnerEnvironments(this.partnerShortCode).subscribe(response => {
      if (response) {
        this.allEnvironments = response;
        this.currentEnvironment = this.allEnvironments[0];
        this.onEnvironmentChange.emit(true);
        this.isDataSet = true;
      }
    });
  }
}
